'use strict';

var SystemStatusHistoryDirective = function SystemStatusHistoryDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-history.html'),
    controller: 'SystemStatusHistoryController'
  };
};
SystemStatusHistoryDirective.$inject = [];
module.exports = SystemStatusHistoryDirective;